import { Grid2X2, List } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useTranslation } from 'react-i18next';
import { useIsMobile } from "@/hooks/use-mobile";

interface InventoryViewToggleProps {
  view: "grid" | "list";
  onViewChange: (view: "grid" | "list") => void;
}

export function InventoryViewToggle({ view, onViewChange }: InventoryViewToggleProps) {
  const isMobile = useIsMobile();
  
  return (
    <ToggleGroup 
      type="single" 
      value={view} 
      onValueChange={(value) => value && onViewChange(value as "grid" | "list")}
      className="bg-background/40 backdrop-blur-sm border border-white/10 p-1 rounded-xl"
    >
      <ToggleGroupItem 
        value="grid" 
        aria-label="Grid view"
        className={`${isMobile ? 'h-11 w-11' : 'h-9 w-9'} rounded-lg data-[state=on]:bg-white/20 data-[state=on]:text-white hover:bg-white/10`}
      >
        <Grid2X2 className={`${isMobile ? 'h-5 w-5' : 'h-4 w-4'}`} />
      </ToggleGroupItem>
      <ToggleGroupItem 
        value="list" 
        aria-label="List view"
        className={`${isMobile ? 'h-11 w-11' : 'h-9 w-9'} rounded-lg data-[state=on]:bg-white/20 data-[state=on]:text-white hover:bg-white/10`}
      >
        <List className={`${isMobile ? 'h-5 w-5' : 'h-4 w-4'}`} />
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
